var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTransferShares = function SvgTransferShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 57,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.822 23.226v7.563l21.177-15.127L87.822.535V8.1h-53.7v15.127h53.7zM21.178 33.69v-7.564L.001 41.253 21.178 56.38v-7.563h53.7V33.69h-53.7z",
    fill: "#33BB40"
  })));
};

export default SvgTransferShares;